import script from "./Home_Historico.vue?vue&type=script&setup=true&lang=js"
export * from "./Home_Historico.vue?vue&type=script&setup=true&lang=js"

import "./Home_Historico.vue?vue&type=style&index=0&id=48ab6254&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48ab6254"]])

export default __exports__